import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { AvailableLanguages } from '@repo/toolkit/language-types'
import { TFunction } from 'i18next'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import useTranslate from '../../../lib/hooks/use-translate'
import { TripProviderContactInput } from '../../../lib/types/models/trip-provider/trip-provider-contact-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { PHONE_NUMBER_SCHEMA } from '../../../lib/utils/validations/phone-number.validation'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledPhoneInput from '../../elements/inputs/controlled-phone-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<TripProviderContactInput> & {
  className?: string
}

const formSchema: (
  t: TFunction<AvailableLanguages, undefined>
) => ZodType<TripProviderContactInput> = (t) =>
  z.object({
    firstName: createStringSchema('Prénom'),
    lastName: createStringSchema('NOM'),
    email: createStringSchema('Email', { isEmail: true }),
    position: createStringSchema('Fonction'),
    phoneNumber: PHONE_NUMBER_SCHEMA(t)
  })

const TripProviderContactForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: Props) => {
  const { t } = useTranslate()
  const form = useForm<TripProviderContactInput>({
    resolver: zodResolver(formSchema(t)),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form>
        <div className={cn('flex flex-col gap-3', className)}>
          <FormField
            control={form.control}
            name={'position'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput {...field} label={'Fonction'} type="text" required />
                </FormControl>
              </FormItem>
            )}
          />

          <div className="flex gap-3">
            <FormField
              control={form.control}
              name={'lastName'}
              render={({ field }) => (
                <FormItem className={'flex-1'}>
                  <FormControl>
                    <ControlledInput {...field} label={'NOM'} type="text" required />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'firstName'}
              render={({ field }) => (
                <FormItem className={'flex-1'}>
                  <FormControl>
                    <ControlledInput {...field} label={'Prénom'} type="text" required />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>

          <div className="flex gap-3">
            <FormField
              control={form.control}
              name={'email'}
              render={({ field }) => (
                <FormItem className={'flex-1'}>
                  <FormControl>
                    <ControlledInput {...field} label={'Email'} type="email" required />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name={'phoneNumber'}
              render={({ field }) => (
                <FormItem className={'flex-1'}>
                  <FormControl>
                    <ControlledPhoneInput
                      {...field}
                      required
                      label={'Numéro de téléphone'}
                      defaultCountry="FR"
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default TripProviderContactForm
